import { Extension, InputRule } from '@tiptap/core'
import type { EditorState } from '@tiptap/pm/state'

type InputRange = {
    from: number
    to: number
}

// Number typed right under an ordered list that continues it, so Tiptap's own rule
// can join the new item onto that list.
function continuesListAbove(state: EditorState, range: InputRange, number: number): boolean {
    const $start = state.doc.resolve(range.from)
    const before = $start.index($start.depth - 1)
    if (before === 0) return false

    const previous = $start.node($start.depth - 1).child(before - 1)
    if (previous.type.name !== 'orderedList') return false

    const start = Number(previous.attrs.start) || 1
    return start + previous.childCount === number
}

// Tiptap turns any "<number>. " at the start of a line into an ordered list, so
// prose like "100. " became a list starting at 100. Only "1. " (or the next number
// of the list directly above) starts a list; other numbers stay as typed text.
export const PreserveNumberedTextInputRule = Extension.create({
    name: 'preserveNumberedTextInputRule',
    priority: 1_000,

    addInputRules() {
        return [
            new InputRule({
                find: /^(\d+)\.\s$/,
                undoable: false,
                handler: ({ state, range, match }) => {
                    const number = Number(match[1])
                    if (number === 1 || continuesListAbove(state, range, number)) return null

                    state.tr.insertText(' ', range.to)
                },
            }),
        ]
    },
})

export default PreserveNumberedTextInputRule
